import { useApiMutation } from "./use-api-mutation";
import { useInvalidateReturnRequest } from "./use-invalidate-return-request";

type CancelReturnRequestParams = {
	returnRequestId: string;
	shopId: string;
};

export default function useCancelReturnRequest() {
	const invalidateReturnRequest = useInvalidateReturnRequest();

	return useApiMutation(
		"post",
		"/shops/{shopId}/return-requests/{returnRequestId}/cancel",
		{
			onSuccess: (_data, variables: CancelReturnRequestParams) => {
				invalidateReturnRequest({
					returnRequestId: variables.returnRequestId,
					shopId: variables.shopId,
				});
			},
			mapVariables: ({ returnRequestId, shopId }: CancelReturnRequestParams) => ({
				params: { path: { returnRequestId, shopId } },
			}),
		},
	);
}
